import {
  MultiProviderTokenSelector,
  SnowToken,
  TokenStorage,
  TokenSupplier,
  AuthUser,
  TokenUser,
} from "@mysnowscape/snow-lib";
import {
  Auth,
  getAuth,
  getIdToken,
  onAuthStateChanged,
  Unsubscribe,
  User,
} from "firebase/auth";
import firebaseAuth from "../firebase/firebaseAuth";

// Setup a wrapper class for firebase that implements our TokenSupplier class.
class FirebaseTokenSupplier implements TokenSupplier {
  async getCurrentUser(): Promise<AuthUser | null> {
    const user = await firebaseGetCurrentUser(getAuth());
    if (user) {
      return this.fbUserToAuthUser(user);
    }
    return null;
  }
  fbUserToAuthUser(fbUser: User): AuthUser {
    return {
      phone_number: fbUser.phoneNumber ?? "",
      user_id: fbUser.uid,
    };
  }
  subscribers = new Map<(user: AuthUser | null) => void, Unsubscribe>();
  async getToken(): Promise<string | null> {
    const user = await firebaseGetCurrentUser(getAuth());

    if (user) {
      const token = await getIdToken(user);
      console.log("supplying a token from firebase");
      return token;
    } else {
      return null;
    }
  }
  signOut(): Promise<void> {
    return new Promise((resolve, reject) =>
      firebaseAuth.signOut(resolve, reject),
    );
  }
  subscribe(
    callback: (user: AuthUser | null) => void,
  ): (user: AuthUser | null) => void {
    const unsubscribe = onAuthStateChanged(firebaseAuth.auth, (fbUser) => {
      const authUser: AuthUser | null =
        fbUser === null
          ? null
          : {
              phone_number: fbUser.phoneNumber!,
              user_id: fbUser.uid,
            };
      callback(authUser);
    });
    this.subscribers.set(callback, unsubscribe);
    return callback;
  }
  unsubscribe(callback: (user: TokenUser | null) => void): void {
    const fnc = this.subscribers.get(callback);
    if (fnc) {
      fnc();
      this.subscribers.delete(callback);
    }
  }
}
const storage: TokenStorage = {
  setItem: function (key: string, value: string | null): Promise<void> {
    if (value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
    return Promise.resolve();
  },
  getItem: function (key: string): Promise<string | null> {
    return Promise.resolve(window.localStorage.getItem(key));
  },
};

/**
 * Here we setup a tokenSupplier that will get a token from either firebase or from SnowToken.
 */
const firebaseTokenSupplier = new FirebaseTokenSupplier();
export const snowTokenSupplier = new SnowToken(
  storage,
  process.env.REACT_APP_BACKEND_API ?? "https://api.mysnowscape.com/v2/",
);
export const tokenSupplier = new MultiProviderTokenSelector([
  firebaseTokenSupplier,
  snowTokenSupplier,
]);

/**
 * Firebase takes a bit to load.  This function will wait for auth to be ready before returning the state.
 */
function firebaseGetCurrentUser(auth: Auth): Promise<User | null> {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
}
